import { Button, Descriptions, Table, Tag, Dropdown, Popconfirm, Space } from "antd";
import { useNavigate, useParams, useRouteLoaderData } from "react-router";
import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { fieldTypes } from "./PosModelFields";
import BackTitle from "../common/BackTitle";
import { api } from "../common/api";

export default function PosModel() {
  const navigate = useNavigate();
  const data = useRouteLoaderData("posModel");
  const { id } = useParams();

  const items = [
    { key: "name", label: "Nome", children: data.name },
    {
      key: "sections",
      label: "Sezioni",
      children: (
        <Space wrap>
          {(data.sections ?? []).map((name) => (
            <Tag key={name}>{name}</Tag>
          ))}
        </Space>
      ),
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      <BackTitle
        backEnabled={false}
        title="Dettagli modello POS"
        secondary={`ID: ${id}`}
        extra={
          <Space size={4}>
            <Dropdown
              trigger={["click"]}
              menu={{
                items: [
                  {
                    key: "deletePosModel",
                    label: (
                      <Popconfirm
                        title="Conferma rimozione"
                        onConfirm={() => api.posModel.delete(id).then(() => navigate(".."))}
                        description="L'operazione è irreversibile. Procedendo, i dati verranno rimossi definitivamente."
                      >
                        Elimina
                      </Popconfirm>
                    ),
                    danger: true,
                    icon: <DeleteOutlined />,
                  },
                ].filter((x) => !!x),
              }}
            >
              <Button icon={<MoreOutlined />} />
            </Dropdown>
          </Space>
        }
      />
      <Descriptions
        layout="vertical"
        title={
          <>
            Informazioni generali
            <Button type="link" icon={<EditOutlined />} onClick={() => navigate("edit")} />
          </>
        }
        column={3}
        colon={false}
        items={items}
      />
      <Table
        rowKey="name"
        title={() => "Campi del modello"}
        pagination={false}
        dataSource={data.formItems}
        columns={[
          { title: "Nome", dataIndex: "name", key: "name" },
          {
            title: "Tipo",
            dataIndex: "type",
            key: "type",
            render: (type) => fieldTypes.find((x) => x.value === type)?.label ?? type,
          },
        ]}
      />
    </div>
  );
}
